export const getCookieValue = (cookieName) => {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === cookieName) {
      return decodeURIComponent(value);
    }
  }
  return null;
}

export const getProductInstanceId = () => {
  return getCookieValue('_sp_productInstanceId');
}

export const getHomeUrl = () => {
  return 'https://www.networksolutions.com/my-account/home';
}

export const getCheckoutAccountUrl = () => {
  const dnsProdInst = getCookieValue('checkout_dnsProdInst')
  if (dnsProdInst) {
    return `https://www.networksolutions.com/my-account/checkout/${dnsProdInst}/orders`
  }
  return 'https://www.networksolutions.com/my-account/checkout'
}

export const getPostPublishUrl = () => {
  return `${getCheckoutAccountUrl()}?action=published`
}